<dx-popup #autoLogoutWarningPopup [width]="400" [height]="200" [showTitle]="true" title="Auto Logout Warning"
    [dragEnabled]="false" [showCloseButton]="false" [hideOnOutsideClick]="false" [(visible)]="popupVisible">
    <div *dxTemplate="let data of 'content'">

        <div>This session will be closed in {{ timeLeft | timeFormat }} and you will be logged out because of
            an extended period of inactivity. Click the 'OK' button to continue your session.</div>
        <br />
        <div style="float:right">
            <dx-button stylingMode="contained" text="OK" type="primary" [width]="120" (onClick)="btnOk($event)">
            </dx-button>
        </div>
    </div>
</dx-popup>